import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { environmentURLs } from '../../../../../common/environment/CaptureEnvironment';
import LearnMore from '../../../../../common/LearnMore/LearnMore';

class AppActivationHeader extends Component {
  constructor(props) {
    super(props);
  }

  renderSolutionListing = () => {
    const { changeMenu } = this.props;
    return changeMenu('manageListing');
  };

  render() {
    return (
      <div>
        <div className="app-activation-help-text">
          <FormattedMessage
            id="AppActivation.helpText1"
            defaultMessage={`App activation help text`}
          />
          <span
            className="app-activation-link"
            onClick={this.renderSolutionListing}
          >
            <FormattedMessage
              id="AppActivation.editApp"
              defaultMessage={`App activation edit app`}
            />
          </span>
          <FormattedMessage
            id="AppActivation.helpText2"
            defaultMessage={`App activation help text`}
          />
          &nbsp;
          <LearnMore
            url={`${
              environmentURLs.docs
            }docs/tutorials/app-lifecycle/managing-app-activations/#the-app-activations-page`}
          />
        </div>
        <div />
      </div>
    );
  }
}

export default AppActivationHeader;
